export const createPermissionsWarning = (...permissions: [itemType: string, action: string][]): string => {
  const lines = permissions.map((permission) => `<p>${permission.join(' - ')} permission required</p>`).join('');

  return `<div class="shepherd-permissions-warning">${lines}</div>`;
};
